// ============================================================================
// SAMPLE SERVICE ENDPOINTS (Reference Implementation)
// ============================================================================
// Endpoint definitions for Sample Service Master module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/sample-services';

export const sampleServiceEndpoints = {
  /** GET /api/v1/sample-services */
  list: () => buildEndpoint(BASE_PATH),

  /** GET /api/v1/sample-services/:id */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** GET /api/v1/sample-services/code/:code */
  getByCode: (code: string) => buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),

  /** POST /api/v1/sample-services */
  create: () => buildEndpoint(BASE_PATH),

  /** PUT /api/v1/sample-services/:id */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** DELETE /api/v1/sample-services/:id */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** GET /api/v1/sample-services/validate/code/:code */
  validateCode: (code: string) =>
    buildEndpointWithParams(`${BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default sampleServiceEndpoints;
